/**
 * Simple Form Calculator component
 * @param {string} productContainer - The container of the product. <form data-app-product></form>
 * @param {string} selectedPrices - The selected prices. <input data-app-price="100" checked></input>
 * @param {string} priceElement - Node selector for render total price. <span data-app-total></span>
 * @param {string} priceAltElement - Node selector for render alternative total price (like old price). <span data-app-total-alt></span>
 * @param {function} priceAltFunc - Alternative price function. (price) => price * 0.7
 * @param {int} priceDecimals - Number of decimals for price.
 * @param {bool} animateNumber - Animate number on price change.
 */

let _config = {
    productContainer: 'form[data-app-product]',
    selectedPrices: 'select[data-app-price]',
    priceElement: '[data-app-total]',
    priceAltElement: '[data-app-total-alt]',
    priceAltFunc: (price) => parseFloat(price / 0.7),
    priceDecimals: 0,
    animateNumber: true
}

const simpleCalculator = (config = {}) => {
    _config = {..._config, ...config}
    const products = document.querySelectorAll(_config.productContainer)

    // Do not animate prices on page load
    let animateCallback = changeNumber

    products.forEach(product => {
        product.addEventListener('change', () => {
            changeProductPrice(product, getProductPrice(product), animateCallback)
        })
        product.dispatchEvent(new Event('change'))
    })

    if (_config.animateNumber) animateCallback = animateNumber
}

const getProductPrice = (product) => {
    const prices = product.querySelectorAll(_config.selectedPrices)
    
    return Array.from(prices).reduce((sum, el) => sum += parseFloat(el.value) || 0, 0)
}

const changeProductPrice = (product, price, animationCallback) => {
    const priceElement = product.querySelector(_config.priceElement)
    const priceAltElement = product.querySelector(_config.priceAltElement)

    if (priceElement) animationCallback(price, priceElement)
    if (priceAltElement) priceAltElement.textContent = renderPrice(_config.priceAltFunc(price))
}

const changeNumber = (number, node) => {
    node.textContent = renderPrice(number)
    node.dataset.from = renderPrice(number)
}

const animateNumber = (number, node) => {
    const from = Number(node.dataset.from || node.textContent || 0);
    const to = Number(number);
    const time = {
        start: performance.now(),
        duration: 500,
    };
    const tick = function (now) {
        const progress = Math.min((now - time.start) / time.duration, 1);
        const easing = Math.pow(progress - 1, 5) + 1;
        const value = from + (to - from) * easing;
        node.textContent = renderPrice(value);
        if (progress < 1) {
            requestAnimationFrame(tick);
        } else {
            node.dataset.from = renderPrice(to);
            node.textContent = renderPrice(to);
        }
    };
    requestAnimationFrame(tick);
};

const renderPrice = (num) => parseFloat(num).toFixed(_config.priceDecimals)

export default simpleCalculator